import * as React from 'react';
import { IAppState, ThemeContext, ITheme } from '../../app';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch, Redirect } from 'react-router';
import { withRouter } from 'react-router-dom';
import * as queryString from 'query-string';
import * as Configuration from './configuration/index'
import { IPageConfig, RoutePermission, UserRole } from './configuration/IConfiguration';
import * as DTOS from "../../FeralScan.dtos";

import * as DashboardActionCreators from "../../actions/dashboard.actions";
import * as UserActionCreators from "../../actions/user.actions";
import Loader from 'react-loaders';
import { ReferenceDataState } from '../../reducers/referenceData.reducer';
import ScrollToTop from './Common/ScrollToTop';

interface IFrameworkProps {
    currentUser: DTOS.User;
    currentUserLoading: boolean;
    history: any;
    loginActive: boolean;
    loggingIn: boolean;
    loginStatusUnknown: boolean;
    match: any;
    referenceData: ReferenceDataState;
}

interface IFrameworkActions {
    getReferenceData: typeof DashboardActionCreators.getReferenceDataRequest;
    getCurrentUser: typeof UserActionCreators.getCurrentUserRequest;
    updateUserPreferences: typeof UserActionCreators.updateUserPreferencesRequest;
}

type FrameworkProps = IFrameworkProps & IFrameworkActions;

interface IFrameworkState {
    frameworkContext: ITheme,
}

class Framework extends React.Component<FrameworkProps, IFrameworkState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            frameworkContext: {
                classification: '',
                route: '',
                theme: '',
                setThemeContext: this.setThemeContext
            }
        }
    }

    componentWillMount() {
        if (!this.props.loggingIn) {
            this.props.getReferenceData();
        }
    }

    componentDidUpdate(prevProps: FrameworkProps) {
        const { loggingIn, currentUser, currentUserLoading, referenceData } = this.props;
        // condition for loading page with an already valid session
        if (!loggingIn
            && !currentUser
            && !currentUserLoading
            && referenceData.userHasAuthenticatedSession
            && referenceData.userHasAuthenticatedSession != prevProps.referenceData.userHasAuthenticatedSession) {
            this.props.getCurrentUser();
        }
    }

    setUserPreference(key: string, value: string) {
        var updatedPreferences = { ...this.props.currentUser.userPreferences };

        updatedPreferences[key] = value;

        this.props.updateUserPreferences(updatedPreferences)
    }

    setThemeContext = newContext => {
        if (this.state.frameworkContext.route !== newContext.route
            || this.state.frameworkContext.theme !== newContext.theme) {
            this.setState({
                frameworkContext: {
                    classification: newContext.classification,
                    route: newContext.route,
                    theme: newContext.theme,
                    setThemeContext: this.setThemeContext
                }
            });
        }
    };

    render() {

        const { } = this.props;

        const commonProps = {
            currentUser: this.props.currentUser,
            currentUserLoading: this.props.currentUserLoading,
            history: this.props.history,
            loginActive: this.props.loginActive,
            setUserPreference: (key, value) => this.setUserPreference(key, value),
            websiteSettings: this.props.referenceData ? this.props.referenceData.websiteSettings : undefined,
            defaultDateFormat: Configuration.AppConfig.defaultDateFormat,
            defaultDateTimeFormat: Configuration.AppConfig.defaultDateTimeFormat
        };

        const path = this.props.match.path;

        const unknownAuth = (!this.props.referenceData || this.props.referenceData.userHasAuthenticatedSession === undefined)
            || (this.props.referenceData.userHasAuthenticatedSession && this.props.loginStatusUnknown);

        const routes = Configuration.PageGroups.map((pagegroup, pg) => {
            return pagegroup.pages.map((page, px) => {
                switch (page.type) {
                    case "PAGE":
                        return page.route.map((route, rx) => {

                            const classificationRoute = pagegroup.classificationRoute ? pagegroup.classificationRoute + '/' : '';

                            return <Route
                                key={`route-${pg}-${px}-${rx}`}
                                path={`${path}${classificationRoute}${route}`}
                                exact={true}
                                render={(routeProps) => {
                                    const Component = pagegroup.pageLayout.component;


                                    //this.setThemeContext({ classification: pagegroup.classification, theme: pagegroup.theme, route: pagegroup.classificationRoute });

                                    return [
                                        <div key="theme-switcher">{ThemeSwitcher({ classification: pagegroup.classification, theme: pagegroup.theme, route: pagegroup.classificationRoute })}</div>,
                                        <Component
                                            key={'layout'}
                                            {...commonProps}
                                            pages={pagegroup.pages}
                                            generateSideBar={page.generateSideBar}
                                            generateLegendFindings={page.generateLegendFindings}
                                            generateLegendSiteSelect={page.generateLegendSiteSelect}
                                        >
                                            {this.checkRoutePermission(this.renderPage(page, commonProps, routeProps),
                                                page.routePermission,
                                                page.routeRole,
                                                page.routePermissionRedirectTo ? page.routePermissionRedirectTo : "/",
                                                this.props.currentUser,
                                                unknownAuth)}

                                        </Component>]
                                }}
                            />
                        });
                    default:
                        return null;
                }
            });
        });

        return (<ThemeContext.Provider
            value={this.state.frameworkContext}
        >
            <ScrollToTop>
                <Switch>
                    {routes}
                    <Redirect exact path={"/"} to={Configuration.AppConfig.defaultRoute} />
                    <Redirect path={"*"} to={`/404`} />
                </Switch>
            </ScrollToTop>
        </ThemeContext.Provider>
        );
    }

    checkRoutePermission(component: any, routePermission: RoutePermission, routeRole: UserRole, redirectTo: string, currentUser: DTOS.User, loginUnknown: boolean) {
        const hasPermission = !routePermission
            || (routePermission === RoutePermission.LOGGED_IN_ONLY && currentUser)
            || (routePermission === RoutePermission.LOGGED_OUT_ONLY && !currentUser);

        const hasRole = !routeRole || (currentUser !== undefined && currentUser.userRoles && currentUser.userRoles.find(r => r === routeRole));

        if (loginUnknown && (!hasPermission || !hasRole)) {
            return <div className="position-absolute"
                style={{ bottom: '50%', left: '42%' }}>
                <Loader type="ball-scale-multiple" active />
                <div className="ml-4 small">loading</div>
            </div>;
        }

        return hasPermission && hasRole ? component : <Redirect to={redirectTo} />;
    }

    renderPage(page: IPageConfig, commonProps: any, routeProps: RouteComponentProps) {
        const Component = page.component;

        const queryParams = queryString.parse(location.search)

        return <Component
            {...commonProps}
            location={routeProps.location}
            routeParams={routeProps.match.params}
            queryParams={queryParams}
            {...page.configurationProps}
        />
    }
}

class InnerThemeSwitcher extends React.Component<any> {
    componentDidMount() {
        const { context, newContext } = this.props;

        context.setThemeContext(newContext)
    }

    render() {
        return null;
    }
}

const ThemeSwitcher = (newContext) => (
    <ThemeContext.Consumer>
        {context =>
            <InnerThemeSwitcher context={context} newContext={newContext} />
        }
    </ThemeContext.Consumer>
)

const mapStateToProps = (state: IAppState) => {

    return {
        currentUser: state.user.currentUser,
        currentUserLoading: state.user.loading,
        loginActive: state.user.loginActive,
        loggingIn: state.user.loggingIn,
        loginStatusUnknown: state.user.loginStatusUnknown,
        referenceData: state.referenceData,
        //websiteSettings: state.referenceData.websiteSettings ? state.referenceData.websiteSettings : undefined
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getReferenceData: DashboardActionCreators.getReferenceDataRequest,
        updateUserPreferences: UserActionCreators.updateUserPreferencesRequest,
        getCurrentUser: UserActionCreators.getCurrentUserRequest
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Framework));